export default __webpack_public_path__ + "static/media/Sort.aedff4af.svg";